const PALETTE = {
  ok: { fg: "rgb(32,138,78)", bg: "rgba(32,138,78,0.10)", bd: "rgba(32,138,78,0.30)" },
  warn: { fg: "rgb(176,116,18)", bg: "rgba(176,116,18,0.10)", bd: "rgba(176,116,18,0.30)" },
  err: { fg: "rgb(196,52,44)", bg: "rgba(196,52,44,0.10)", bd: "rgba(196,52,44,0.30)" },
  info: { fg: "rgb(36,104,184)", bg: "rgba(36,104,184,0.10)", bd: "rgba(36,104,184,0.30)" },
  neutral: { fg: "rgb(108,96,80)", bg: "rgba(38,31,24,0.05)", bd: "rgba(190,176,152,0.45)" },
};

const STATE_MAP = {
  // visitor-path states
  visitor: "neutral",
  quote_requested: "info",
  quoted: "info",
  hesitating: "warn",
  booked: "ok",
  in_fulfillment: "ok",
  flown: "ok",
  post_flight: "ok",
  repeat: "ok",
  abandoned: "err",
  idle: "warn",
  bounced: "err",
  // booking states
  hold: "warn",
  confirmed: "ok",
  cancelled: "err",
  // quote / payment / contract / generic
  pending: "warn",
  sent: "info",
  viewed: "info",
  accepted: "ok",
  expired: "err",
  declined: "err",
  withdrawn: "neutral",
  signed: "ok",
  captured: "ok",
  requires_review: "warn",
  failed: "err",
  refunded: "neutral",
  pass: "ok",
  fail: "err",
  manual_review: "warn",
  scheduled: "info",
  airborne: "info",
  landed: "ok",
  delayed: "warn",
  diverted: "err",
  // agent task states
  queued: "neutral",
  running: "info",
  succeeded: "ok",
  waiting_human: "warn",
};

export function StatusPill({ state, label, dataTestid }) {
  const tone = PALETTE[STATE_MAP[state] || "neutral"];
  const text = label || (state || "").replace(/_/g, " ");
  return (
    <span
      data-testid={dataTestid}
      title={text}
      className="inline-flex items-center gap-1.5 mono align-middle max-w-full"
      style={{
        background: tone.bg,
        color: tone.fg,
        border: `1px solid ${tone.bd}`,
        padding: "2px 8px",
        fontSize: 10,
        letterSpacing: "0.08em",
        textTransform: "uppercase",
        lineHeight: 1.3,
        whiteSpace: "nowrap",
      }}
    >
      <span
        className="pj-pulse flex-shrink-0"
        style={{
          width: 6,
          height: 6,
          background: tone.fg,
          borderRadius: 999,
          display: "inline-block",
        }}
      />
      <span className="truncate">{text}</span>
    </span>
  );
}

export default StatusPill;
